'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var utils = require('./utils.js');
var Queue = require('./Queue.js');
var Sink = /*#__PURE__*/function () {
  function Sink() {
    _classCallCheck(this, Sink);
    /**
     * @type {Map<string, Queue>}
     */
    this.map = new Map();
  }

  /**
   * @param {string} channel
   * @param {string} topic
   * @returns {Queue}
   */
  return _createClass(Sink, [{
    key: "getQueue",
    value: function getQueue(channel, topic) {
      return this.map.get(utils.toKey(channel, topic)) || new Queue();
    }

    /**
     * @param {import('./Event.js').default} event
     * @returns {void}
     */
  }, {
    key: "push",
    value: function push(event) {
      var queue = this.getQueue(event.channel, event.topic);
      queue.push(event);
      this.map.set(event.toKey(), queue);
    }

    /**
     * @template [T=unknown]
     * @param {string} channel
     * @param {string} topic
     * @returns {import('./Event.js').default<T>}
     */
  }, {
    key: "peek",
    value: function peek(channel, topic) {
      return this.getQueue(channel, topic).peek();
    }

    /**
     * @template [T=unknown]
     * @param {string} channel
     * @param {string} topic
     * @returns {import('./Event.js').default<T>[]}
     */
  }, {
    key: "log",
    value: function log(channel, topic) {
      return this.getQueue(channel, topic).toArray();
    }
  }]);
}();
module.exports = Sink;
